function Input({
  label,
  name,
  type = "text",
  value,
  onChange,
  placeholder,
  error,
  hint,
  className = "",
  labelClassName = "",
  suffix,
  ...props
}) {
  return (
    <div className="block space-y-1">
      {label && (
        <label
          htmlFor={name}
          className={`block text-[11px] font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 ${labelClassName}`.trim()}
        >
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={(e) => {
            if (type === "date" || type === "datetime-local") {
              const year = e.target.value.split("-")[0];
              if (year && year.length > 4) return;
            }
            onChange?.(e);
          }}
          max={
            type === "date"
              ? "9999-12-31"
              : type === "datetime-local"
              ? "9999-12-31T23:59"
              : undefined
          }
          placeholder={placeholder}
          className={`w-full rounded-lg border bg-white px-2 py-1 text-xs text-slate-900 focus:outline-none transition-all placeholder:text-slate-400 focus:ring-2 dark:bg-[#374151] dark:text-[#F9FAFB] ${
            error
              ? "border-danger focus:border-danger focus:ring-danger/20"
              : "border-[#E5E7EB] focus:border-primary-500 focus:ring-primary-500/20 dark:border-[#4B5563] dark:focus:border-primary-dark dark:focus:ring-primary-dark/20"
          } ${suffix ? "pr-10" : ""} ${className}`.trim()}
          {...props}
        />
        {suffix && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
            {suffix}
          </div>
        )}
      </div>
      {error ? (
        <p className="mt-1 text-xs font-medium text-danger">{error}</p>
      ) : hint ? (
        <p className="mt-1 text-xs text-brand-text-secondary dark:text-slate-400">{hint}</p>
      ) : null}
    </div>
  );
}

export default Input;
